module.exports = __webpack_public_path__ + "static/media/arrow-up-down.8257a627.svg";